/* eslint-disable @typescript-eslint/no-explicit-any */

// TODO:VC_AUTH: Debug why using @config/axios is reloading the page when there's an error in the login form (Password mismatch, Verification, etc.)

import axios from 'axios';
import { getAxiosConfig } from '@config/axios';
import { environments } from '@interfaces/vc-auth/environments';
import { Credentials, ResetPasswordRequest, UserCreate } from '@interfaces/vc-auth/login.interfaces';
import { datadogRum } from '@datadog/browser-rum-slim';
import Environment from '@config/index';
import logger from '@helpers/utils/logger';

const env = Environment.envName;
export default class UserService {
  static createSession(payload: Credentials) {
    return this.postMethod(payload, 'createSession');
  }

  static async deleteSession() {
    try {
      const axiosConfig = getAxiosConfig();
      await axios.delete(`${environments[env].apiBaseUrl}/sessions/`, axiosConfig);
    } catch (error) {
      logger.error('vc-auth::deleteSession::user-service::', error?.response?.data);
      datadogRum.addError('vc-auth::deleteSession::user-service::', { error: error?.response?.data });
    }
  }

  static registerUser(payload: UserCreate) {
    return this.postMethod(payload, 'registerUser');
  }

  static async postMethod(payload: Credentials | UserCreate, method: string) {
    if (payload === null || payload === undefined) {
      throw new Error(`Required payload null or undefined when calling ${method}.`);
    }

    try {
      const axiosConfig = await getAxiosConfig();
      const endPoint = method === 'registerUser' ? '/users/' : '/sessions/';
      const res = await axios.post(`${environments[env].apiBaseUrl}${endPoint}`, payload, axiosConfig);
      return res.data;
    } catch (error) {
      logger.error(`vc-auth::postMethod::user-service::${method}::`, error?.response?.data);
      datadogRum.addError(`vc-auth::postMethod::user-service::${method}::`, { error: error?.response?.data });
      throw error;
    }
  }

  static async resetUserPassword(payload: ResetPasswordRequest) {
    if (payload === null || payload === undefined) {
      throw new Error(`Required payload null or undefined when calling resetUserPassword`);
    }

    const axiosConfig = await getAxiosConfig();
    const res = await axios.post(`${environments[env].apiBaseUrl}/reset-password-requests/`, payload, axiosConfig);
    return res.data;
  }

  static async resetPassword(payload: any) {
    if (payload === null || payload === undefined) {
      throw new Error(`Required payload null or undefined when calling resetPassword`);
    }
    const axiosConfig = await getAxiosConfig();
    const res = await axios.patch(`${environments[env].apiBaseUrl}/reset-password/`, payload, axiosConfig);
    return res.data;
  }

  static async validateCaptcha(payload: any) {
    if (payload === null || payload === undefined) {
      throw new Error(`Required payload null or undefined when calling validateCaptcha`);
    }
    try {
      const axiosConfig = await getAxiosConfig();
      const language = axiosConfig.params['x-language'];
      let apiUrl = environments[env].apiFenxUrl;
      if (language !== 'en') {
        apiUrl = apiUrl.replace('www', language === 'ko' ? 'kr' : language);
      }
      const res = await axios.post(`${apiUrl}/captcha-validation/`, payload, axiosConfig);
      return res.data;
    } catch (error) {
      logger.error('vc-auth::validateCaptcha::user-service::', error?.response?.data);
      datadogRum.addError('vc-auth::validateCaptcha::user-service::', { error: error?.response?.data });
      throw error;
    }
  }
}
